module.exports = __webpack_public_path__ + "img/remove--red.e03d94ed.svg";